import i18n from 'i18next';
import { TFunction } from 'i18next';
import { ReactNode } from 'react';
import { translatePartOfStringWithLink } from '../../../lib/StringUtils/StringHTMLUtils';
import { PortalConfiguration } from '../../../types/api/PortalConfiguration';
import { Namespace } from '../../../translation/namespace';
import { FormResponseErrorType } from '../../../components/molecules/Form';

/**
 * Translations of SonResponseErrorTypes.
 * Single Source of Truth for default error type translations in Form2.
 * Only error types with general (Form-de.ts) translations are listed here.
 * Context-specific translations (e.g. invalidColorSpace in ImageUploadForm)
 * are provided via customErrorTypeMessages in the respective form.
 */
export function getDefaultErrorTypeTranslations(
  t: TFunction<'translation', undefined>,
  response: any,
  portalConfiguration?: PortalConfiguration
): ReactNode {
  switch (response.errorType) {
    case 'invalidValue':
      return t('Form:errorType.invalidValue');
    case 'duplicateId':
      return t('Form:errorType.duplicateId');
    case 'maxUploadSizeExceeded':
      return t('Form:errorType.maxUploadSizeExceeded');
    case 'invalidVersionState':
      return t('Form:errorType.invalidVersionState');
    case 'expiredSessionOrCsrf':
      return t('Form:errorType.expiredSessionOrCsrf');
    case 'itemAlreadyExists':
      return t('Form:errorType.itemAlreadyExists');
    case 'surveyInProgress':
      return t('Form:errorType.surveyInProgress');
    case 'invalidHtml':
      return t('Form:errorType.invalidHtml');
    case 'invitedUserAlreadyRegistered':
      return t('Form:errorType.invitedUserAlreadyRegistered');
    case 'pageCreateDuplicateAreaHomePage':
      return t('Form:errorType.pageCreateDuplicateAreaHomePage');
    case 'missingButRequired':
      return t('Form:errorType.missingButRequired');
    case 'pageLocked':
      return translatePartOfStringWithLink('Form:errorType.pageLocked', response.pageLockedBy.url, false, {
        name: response.pageLockedBy.name,
      });
    case 'emailDomainNotAllowed':
      return translatePartOfStringWithLink(
        `${Namespace.Form}:errorType.${FormResponseErrorType.EMAIL_DOMAIN_NOT_ALLOWED}`,
        portalConfiguration?.son_portal_support_email && `mailto:${portalConfiguration.son_portal_support_email}`
      );
    case 'personsNotPrivileged':
      return t('Form:errorType.personsNotPrivileged');
    case 'roleAlreadyExists':
      return t('Form:errorType.roleAlreadyExists');
    default:
      return i18n.exists(`Form:errorType.${response.errorType}`)
        ? t(`Form:errorType.${response.errorType}`)
        : response.errorType;
  }
}
